export var props = {
  // write some props for component
};